<div class="edit-mood-box mb-3">
    <span  (click)="cancelUpdate()">
            <span class="comment-card-cancel"><i class="far fa-times"></i></span>
         </span>
    <div>
        <div class="mb-3 position-relative">
            <label for="kudosRecipient" class="form-label pe-3 fw-bold">{{'kudos.card.edition.recipients' | translate }}</label>
            <tm-kudos-recipients-input-list id="kudosRecipient"
                                            [ngModel]="teamId"
                                            [ngModelOptions]="{standalone: true}"
                                            (ngModelChange)="onTeammatesListChange($event)"
                                            [recipients]="kudos.recipients"></tm-kudos-recipients-input-list>
        </div>

        <div class="mb-3">
            <span class="pe-3 fw-bold">{{'kudos.card.edition.type' | translate }}</span>

            <button class="btn btn-outline-primary me-2 py-1 px-2"
                    [ngClass]="{'active': kudos.kudosType == 'thanks'}"
                    (click)="updateKudosType('thanks')">{{'kudos.activity-modal.type.thank' | translate}} <i class="fa-light fa-hands-holding-heart ps-1"></i></button>
            <button class="btn btn-outline-primary me-2 py-1 px-2"
                    [ngClass]="{'active': kudos.kudosType == 'congratulate'}"
                    (click)="updateKudosType('congratulate')">{{'kudos.activity-modal.type.congratulate' | translate}} <i class="fa-light fa-hands-clapping ps-1"></i></button>
            <button class="btn btn-outline-primary py-1 px-2"
                    [ngClass]="{'active': kudos.kudosType == 'celebrate'}"
                    (click)="updateKudosType('celebrate')">{{'kudos.activity-modal.type.celebrate' | translate}} <i class="fa-sharp fa-light fa-party-horn ps-1"></i></button>
        </div>

    </div>

    <span class="pe-3 pb-1 fw-bold">{{'kudos.card.edition.message' | translate }}</span>
    <div class="card-comment">
         <textarea id="kudos-textarea-to-edit"
                    class="card-comment-body mood-textarea-to-edit"
                    name="kudosMessage"
                    [formControl]='kudosCommentCtrl'
                    [attr.placeholder]="'kudos-request-modal.placeholder' | translate"></textarea>

        <tm-mood-pickers (onElement)="fromMoodPicker($event)"></tm-mood-pickers>

        <div class="timeline-item-to-edit-actions">
            <button (click)="saveUpdate()" class="btn btn-sm btn-outline-secondary"
                  [disabled]="!(kudos.recipients.selectedTeammates?.length || kudos.recipients.allTeamSelected) || !kudos.kudosType || kudos.message.body?.length === 0">
                {{'save' | translate}} <i class="far fa-check"></i>
            </button>
        </div>
    </div>
    @if(error){
    <div class="alert alert-warning position-absolute end-0 py-1" role="alert">
        {{error}}
    </div>
    }
</div>